import React, { useState } from "react";
import PhoneField from "../../components/PhoneField";
import { View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

function StoryComponent({ initialValue }: { initialValue?: string }) {
    const [phone, setPhone] = useState(initialValue);

    return (
        <PhoneField
            initialValue={initialValue}
            value={phone}
            onChangeText={setPhone}
            label="Enter your phone number"
        />
    );
}

const meta = {
    title: "Fields/Phone",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ alignItems: "stretch", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};

export const WithValue: Story = {
    args: {
        initialValue: "+41 79 999 99 01",
    },
};
